import { useContext } from 'react'

import { PulseSurveysContext } from 'context/pulseSurveys/pulseSurveysContext/PulseSurveysContext'
import { PulseSurveysContextValueType } from 'context/pulseSurveys/pulseSurveysContext/PulseSurveysContext.types'

export const usePulseSurveys: () => PulseSurveysContextValueType = () => {
    const context = useContext(PulseSurveysContext)

    if (context === undefined) {
        throw new Error('usePulseSurveys must be used within an PulseSurveysContextController')
    }

    return context
}
